import { Link } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  // ✅ = wired to real anchor | ⚠ = needs real URL before launch
  const links: Record<string, { label: string; href: string }[]> = {
    Product: [
      { label: "How It Works", href: "#how-it-works" },    // ✅
      { label: "Pricing", href: "#pricing" },               // ✅
      { label: "Market Availability", href: "#territory" }, // ✅
      { label: "Territory Access", href: "#territory" },    // ✅
      { label: "Demo Calls", href: "#demo" },               // ✅
    ],
    Company: [
      { label: "About Imperium", href: "#about" },          // ✅
      { label: "Blog", href: "#" },                         // ⚠ no page yet
      { label: "Press", href: "#" },                        // ⚠ no page yet
      { label: "Careers", href: "#" },                      // ⚠ no page yet
      { label: "Contact", href: "#" },                      // ⚠ no page yet
    ],
    Legal: [
      { label: "Privacy Policy", href: "/privacy" },        // ✅ live page
      { label: "Terms of Service", href: "/terms" },        // ✅ live page
      { label: "TCPA Compliance", href: "#" },              // ⚠ no page yet
      { label: "SOC 2 Report", href: "#" },                 // ⚠ no page yet
    ],
  };

  // ⚠ Replace these with real social profile URLs before launch
  const socials = [
    { icon: "ri-twitter-x-line", href: "#", label: "Twitter / X" },
    { icon: "ri-linkedin-box-line", href: "#", label: "LinkedIn" },
    { icon: "ri-youtube-line", href: "#", label: "YouTube" },
  ];

  return (
    <footer className="bg-[#f8fafc] border-t border-gray-200 pt-10 md:pt-16 pb-8 md:pb-10 px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Brand + links grid */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 md:gap-10 mb-8 md:mb-14">
          {/* Brand */}
          <div className="md:col-span-2">
            <p className="text-navy font-extrabold text-xl tracking-tight mb-4">IMPERIUM</p>
            <p className="text-[#4a5568] text-sm leading-relaxed mb-6 max-w-xs">
              AI-powered outbound calling built exclusively for title companies and mortgage professionals.
              Own the moment that wins your next closing.
            </p>
            <div className="flex items-center gap-3">
              {socials.map(({ icon, href, label }) => (
                <a
                  key={icon}
                  href={href}
                  aria-label={label}
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center border border-gray-200 rounded-lg text-[#4a5568] hover:text-navy hover:border-gray-300 transition-colors cursor-pointer"
                >
                  <i className={`${icon} text-sm`} />
                </a>
              ))}
            </div>

            {/* Certifications */}
            <div className="flex items-center gap-3 mt-6">
              <div className="flex items-center gap-1.5 bg-white border border-gray-200 rounded-lg px-3 py-1.5">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-shield-check-fill text-green-500 text-xs" />
                </span>
                <span className="text-navy text-xs font-semibold">SOC 2 Type II</span>
              </div>
              <div className="flex items-center gap-1.5 bg-white border border-gray-200 rounded-lg px-3 py-1.5">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-scales-3-line text-secondary text-xs" />
                </span>
                <span className="text-navy text-xs font-semibold">TCPA Compliant</span>
              </div>
            </div>
          </div>

          {/* Links — 2-col on mobile, then individual on md+ */}
          <div className="grid grid-cols-2 md:contents gap-x-6 gap-y-8">
            {Object.entries(links).map(([category, items], catIndex) => (
              <div key={category} className={catIndex === 2 ? "col-span-2 md:col-span-1" : ""}>
                <p className="text-navy font-semibold text-xs uppercase tracking-widest mb-2 md:mb-4">{category}</p>
                <ul className="flex flex-col">
                  {items.map(({ label, href }) => (
                    <li key={label}>
                      {href.startsWith("/") ? (
                        <Link
                          to={href}
                          className="flex items-center text-[#4a5568] text-sm hover:text-navy transition-colors cursor-pointer py-2"
                        >
                          {label}
                        </Link>
                      ) : (
                        <a
                          href={href}
                          rel="nofollow"
                          className="flex items-center text-[#4a5568] text-sm hover:text-navy transition-colors cursor-pointer py-2"
                        >
                          {label}
                        </a>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[#4a5568] text-xs">
            &copy; {currentYear} Imperium AI, Inc. All rights reserved.
          </p>
          <p className="text-[#4a5568] text-xs text-center sm:text-right">
            AI calling infrastructure for title &amp; mortgage professionals.
            Not affiliated with any MLS provider.
          </p>
        </div>
      </div>
    </footer>
  );
}
